import { useCallback, useState } from 'react';
import type { AuthenticationMethodSchema } from '@zenid/mypage-api';
import { useAuthenticationMethodEnrollments, useDeleteAuthenticationMethods } from './useMfa';

export type MfaResetAlertDialogProps = {
  isOpen: boolean;
  createMfaUrl: () => Promise<string | null>;
  deleteMfaMethod: () => Promise<void>;
  setIsOpen: (isOpen: boolean) => void;
  closeDialog: () => void;
};

export function useMfaResetAlertDialog(authenticationMethods?: AuthenticationMethodSchema[]): MfaResetAlertDialogProps {
  const { postMfaUrl } = useAuthenticationMethodEnrollments();
  const { deleteMfa } = useDeleteAuthenticationMethods();
  const [isOpen, setIsOpen] = useState(false);
  const closeDialog = useCallback(() => setIsOpen(false), []);
  const createMfaUrl = useCallback(async () => {
    const result = await postMfaUrl();
    if (!result.response.ok) {
      return null;
    }
    const createMfaUrl = result.response.headers.get('Location');
    return createMfaUrl;
  }, [postMfaUrl]);
  const deleteMfaMethod = useCallback(async () => {
    if (!authenticationMethods) {
      // MFA認証方法を持っていないのであれば、deleteMfaMethod()は処理せず成功を返す
      return Promise.resolve();
    }
    const authenticationMethodId = authenticationMethods[0]?.id;
    if (!authenticationMethodId) {
      throw new Error('AuthenticationMethodId is undefined...');
    }
    const result = await deleteMfa(authenticationMethodId);
    if (!result.response.ok) {
      throw new Error('Failed to delete authentication method...');
    }
  }, [authenticationMethods, deleteMfa]);
  return {
    isOpen,
    createMfaUrl,
    deleteMfaMethod,
    setIsOpen,
    closeDialog,
  };
}
